import { Nullable } from 'utils/types';
import { stringToBool } from 'utils/form/formUtils';
import { format } from 'utils/date';

export const fromApiToDomainMapper = {
  mapDate: (date: Nullable<string>): string => {
    return date ? format(date).fromBackendToView() : '';
  },
};

export const fromDomainToApiMapper = {
  mapNumber: (value: Nullable<string | number>): Nullable<number> => {
    return value ? Number(value) : null;
  },
  mapYesNo: (value: Nullable<string>): Nullable<boolean> => {
    return value === '' || value === null ? null : stringToBool(value);
  },
  mapDate: (value: Nullable<string>): Nullable<string> => {
    return value ? format(value).fromViewToRequest(true) : null;
  },
};

const exportObject = {
  fromApiToDomain: () => fromApiToDomainMapper,
  fromDomainToApi: () => fromDomainToApiMapper,
};

export default exportObject;
